import {
  ExtractionSettings,
  KeywordSearchCard,
  useAdvancedYoutubeSearch,
} from "@features/AdvancedYoutubeSearch";
import { ROUTES } from "@app/constants";
import { useAuth } from "@entities/auth";
import { CircularProgress, Typography } from "@shared/ui";
import {
  YoutubeSearchResultsTable,
  YoutubeSearchStats,
} from "@widgets/YoutubeSearchResults";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import styles from "./AdvancedYoutubeSearchPage.module.scss";

const { Title, Text } = Typography;

export function AdvancedYoutubeSearchPage() {
  const { beUser, isBeUserLoading } = useAuth();
  const canAccess =
    beUser?.permissions?.includes("super") ||
    beUser?.permissions?.includes("allocate-planning");
  const {
    keywords,
    setKeywords,
    dateRangePreset,
    setDateRangePreset,
    maxResults,
    setMaxResults,
    items,
    isLoading,
    canExtract,
    handleExtract,
  } = useAdvancedYoutubeSearch();
  const [isSettingsOpen, setIsSettingsOpen] = useState(true);

  if (isBeUserLoading) {
    return <CircularProgress />;
  }

  if (!canAccess) {
    return <Navigate to={ROUTES.BRIEF} replace />;
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <Title level={2} className={styles.title}>
          Advanced YouTube Search
        </Title>
        <Text className={styles.subtitle}>
          Track brand campaigns, scrape regional and national influencer
          rosters, and export deep metadata.
        </Text>
      </div>

      <KeywordSearchCard
        keywords={keywords}
        onKeywordsChange={setKeywords}
        onExtract={handleExtract}
        canExtract={canExtract}
        isLoading={isLoading}
        isSettingsOpen={isSettingsOpen}
        onToggleSettings={() => setIsSettingsOpen((open) => !open)}
      />
      {/* <ExtractionProgress isLoading={isLoading} /> */}

      <div className={styles.content}>
        <div className={styles.results}>
          <YoutubeSearchStats items={items} />
          <YoutubeSearchResultsTable items={items} isLoading={isLoading} />
        </div>
        <aside
          className={`${styles.settingsSidebar} ${
            isSettingsOpen ? styles.entering : styles.exiting
          }`}
        >
          <ExtractionSettings
            dateRangePreset={dateRangePreset}
            onDateRangePresetChange={setDateRangePreset}
            maxResults={maxResults}
            onMaxResultsChange={setMaxResults}
            onCollapse={() => setIsSettingsOpen(false)}
          />
        </aside>
      </div>
    </div>
  );
}
